import { displayDateText } from "@Util/moment.util";

export const adaptCycleOrderChange = (raw={}) => {
	const {
		effectID,
		title,
		isEffection,
		effectTypeText,
		createDate,
		effectDate,
		employeeName,
		url,
		suspendStartDate,
		suspendEndDate,
		suspendReasonText,
		suspendNote,
		unsubscribeReasonText,
		unsubscribeNote,
	} = raw || {};

	const getTitle = (title, isEffection, effectTypeText) => {
		let _title = title || '循環訂單'; 
		if (isEffection) {
			_title = '變更';
			if (Array.isArray(effectTypeText)) _title += effectTypeText.join('、');
		} else {
			_title += '成立';
		}
		return _title;
	};

	const descList = [];

	if (suspendStartDate || suspendEndDate) {
		descList.push({
			label: "暫停期間",
			text: displayDateText(suspendStartDate, suspendEndDate)
		});
	}

	if (suspendReasonText) {
		descList.push({text: `${suspendReasonText}${suspendNote && `；${suspendNote}`}`});
	}

	if (unsubscribeReasonText) {
		descList.push({text: `${unsubscribeReasonText}${unsubscribeNote && `；${unsubscribeNote}`}`});
	}

	return (
		{
			id: effectID,
			type: "membership",
			title: getTitle(title, isEffection, effectTypeText),
			pdfUrl: url,
			canDelete: false,

			// 卡片主內容說明區塊
			descList,

			// Timeline 上方額外顯示的 meta
			timelineMetainfo: [
				{ label: "申請日期", text: displayDateText(createDate) },
				{ label: "生效日期", text: displayDateText(effectDate) },
				{ label: "擔當", text: employeeName || '未知' },
			]
		}
	);
};
